export function preventDefaultAndPropagation(e: Event) {
	// Kind of hackish but this solve strange behavior when clicking on the carousel controls which trigger the SearchPOIs query...
	// After some reasearch, whithout this, the cta bubble until triggering the handleRemoveItemStored function in the HistoryResult component.
	e.preventDefault();
	e.stopPropagation();
}
